import React, { useState, useEffect } from 'react';
import {
    Box,
    VStack,
    HStack,
    Select,
    Text,
    Divider,
    FormControl,
    Button,
    Input,
    Textarea,
    useToast,
    Flex,
    FormLabel,
} from '@chakra-ui/react';
import CustomInput from '../../../../components/common/CustomInput'; // Adjust the path if necessary
import CustomLabel from '../../../../components/common/CustomLabel'; // Adjust the path if necessary
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { ACCOUNTS_URL } from '../../../../Globalapi/Globalapi';

function LeftFormSection({ colors }) {
    const toast = useToast();
    const navigate = useNavigate();

    // Separate states for each field
    const [ledgerGroupsList, setLedgerGroupsList] = useState([]);
    const [ledgerName, setLedgerName] = useState('');
    const [ledgerGroupId, setLedgerGroupId] = useState('');
    const [ledgerGroup, setLedgerGroup] = useState('');
    const [description, setDescription] = useState('');
    const [openingBalance, setOpeningBalance] = useState('');
    const [typeOfBalance, setTypeOfBalance] = useState('');
    const [closingBalance, setClosingBalance] = useState('');
    const [typeOfBalanceClosing, setTypeOfBalanceClosing] = useState('');
    const [accountNumber, setAccountNumber] = useState('');
    const [bankName, setBankName] = useState('');
    const [bankBranch, setBankBranch] = useState('');
    const [ifscCode, setIfscCode] = useState('');
    const [bankAddress, setBankAddress] = useState('');
    const [bankPhoneNumber, setBankPhoneNumber] = useState('');
    const [bankEmail, setBankEmail] = useState('');
    const [bankDescription, setBankDescription] = useState('');
    const [micrCode, setMicrCode] = useState('');
    const [bankIntegration, setBankIntegration] = useState('');
    const [mobile, setMobile] = useState('');
    const [email, setEmail] = useState('');
    const [taxNo, setTaxNo] = useState('');
    const [gpDays, setGpDays] = useState('');
    const [address, setAddress] = useState('');
    const [place, setPlace] = useState('');
    const [fieldAdded, setFieldAdded] = useState(false);
    const [ledgerGroupName, setLedgerGroupName] = useState('');
    const initialState = {
        ledgerGroupsList: [],
        ledgerName: '',
        ledgerGroupId: '',
        ledgerGroup: '',
        description: '',
        openingBalance: '',
        typeOfBalance: '',
        closingBalance: '',
        typeOfBalanceClosing: '',
        accountNumber: '',
        bankName: '',
        bankBranch: '',
        ifscCode: '',
        bankAddress: '',
        bankPhoneNumber: '',
        bankEmail: '',
        bankDescription: '',
        micrCode: '',
        bankIntegration: '',
        mobile: '',
        email: '',
        taxNo: '',
        gpDays: '',
        address: '',
        place: '',
        fieldAdded: false,
        ledgerGroupName: '',
    };

    const [state, setState] = useState(initialState);

    const handleAddMoreFields = () => {
        setFieldAdded(true);
    };

    const handleHideFields = () => {
        setFieldAdded(false);
    };

    const resetForm = () => {
        setState({
            ledgerGroupsList: [],
            ledgerName: '',
            ledgerGroupId: '',
            ledgerGroup: '',
            description: '',
            openingBalance: '',
            typeOfBalance: '',
            closingBalance: '',
            typeOfBalanceClosing: '',
            accountNumber: '',
            bankName: '',
            bankBranch: '',
            ifscCode: '',
            bankAddress: '',
            bankPhoneNumber: '',
            bankEmail: '',
            bankDescription: '',
            micrCode: '',
            bankIntegration: '',
            mobile: '',
            email: '',
            taxNo: '',
            gpDays: '',
            address: '',
            place: '',
            fieldAdded: false,
            ledgerGroupName: '',
        });
    };
    


    useEffect(() => {
        const fetchLedgerGroups = async () => {
            try {
                const response = await axios.get(
                    `${ACCOUNTS_URL}/common/ledger_group.php`
                );
                console.log('====================================');
                console.log(response);
                console.log('====================================');

                // Ensure that response.data is an array
                if (Array.isArray(response.data.data)) {
                    setLedgerGroupsList(response.data.data);
                } else {
                    throw new Error('Invalid data format received');
                }
            } catch (error) {
                console.error('Error fetching ledger groups:', error);
                toast({
                    title: 'Error',
                    description: 'Failed to load ledger groups.',
                    status: 'error',
                    duration: 3000,
                    isClosable: true,
                });
            }
        };

        fetchLedgerGroups();
    }, [toast]);

    const handleSubmit = async () => {
        try {
            const payload = {
                ledger_name: ledgerName,
                ledger_group: ledgerGroupId,
                led_discription: description,
                led_opbal: openingBalance,
                closing_bal: closingBalance,
                opbal_type: typeOfBalance,
                cmp_id: sessionStorage.getItem('cmp_id'), // Replace with actual cmp_id from your session logic
                user_id: sessionStorage.getItem('user_id'), // Replace with actual user_id from your session logic
                cu_moble: mobile,
                cu_email: email,
                cu_tin: taxNo,
                cu_gpdays: gpDays,
                cu_address: address,
                cu_place: place,
                bnk_account_no: accountNumber,
                bnk_name: bankName,
                bnk_branch: bankBranch,
                bnk_ifc_code: ifscCode,
                bnk_address: bankAddress,
                bnk_phno: bankPhoneNumber,
                bnk_mail: bankEmail,
                bnk_description: bankDescription,
                bnk_micr: micrCode,
                bnk_intagation: bankIntegration,
            };
            console.log(payload);

            const response = await axios.post(
                `${ACCOUNTS_URL}/ledger/ledger_save.php`,
                payload,
                { headers: { 'Content-Type': 'application/json' } }
            );

            if (response.data.success) {
                toast({
                    title: 'Success',
                    description: 'Ledger details saved successfully!',
                    status: 'success',
                    duration: 3000,
                    isClosable: true,
                });
                resetForm()

            } else {
                throw new Error(response.data.message);
            }
        } catch (error) {
            toast({
                title: 'Error',
                description: error.message,
                status: 'error',
                duration: 3000,
                isClosable: true,
            });
        }
    };
    return (
        <Box
            bg="white"
            borderWidth="1px"
            p={6}
            style={{ borderRadius: '20px' }}
            w="100%"
            minH="750px"
            maxH="750px"  // Set a maximum height to prevent expanding beyond this point
            overflowY="auto"
        >
            <Text fontSize="2xl"  mb={4}>
                Create Ledger
            </Text>
            <Divider mb={4} />

            <VStack spacing={4} align="stretch">
                <HStack spacing={4}>
                    <FormControl isRequired>
                        <CustomLabel labelText="Ledger Name" />
                        <CustomInput
                            placeholder="Enter Ledger Name"
                            value={ledgerName}
                            onChange={(e) => setLedgerName(e.target.value)}
                        />
                    </FormControl>

                    <FormControl isRequired>
                        <CustomLabel labelText="Ledger Group" />
                        <Select
                            placeholder="Select Ledger Group"
                            value={ledgerGroupId}
                            onChange={(e) => {
                                const selectedId = e.target.value; // Get selected id
                                setLedgerGroupId(selectedId); // Set selected id to ledgerGroupId

                                // Set ledgerGroup as well to trigger the conditional logic
                                setLedgerGroup(selectedId);

                                // Find the corresponding ledger group name
                                const selectedGroup = ledgerGroupsList.find(group => group.led_group_id === selectedId);
                                setLedgerGroupName(selectedGroup ? selectedGroup.led_group_name : ''); // Set the group name
                            }}
                        >
                            {Array.isArray(ledgerGroupsList) &&
                                ledgerGroupsList.map((group) => (
                                    <option key={group.led_group_id} value={group.led_group_id}>
                                        {group.led_group_name}
                                    </option>
                                ))}
                        </Select>

                    </FormControl>
                </HStack>

                <FormControl>
                    <CustomLabel labelText="Description" />
                    <CustomInput
                        placeholder="Enter Description"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                    />
                </FormControl>

                <HStack spacing={4}>
                    <FormControl isRequired width="35%">
                        <CustomLabel labelText="Opening Balance" />
                        <CustomInput
                            placeholder="0.00"
                            type="number"
                            value={openingBalance}
                            onChange={(e) => setOpeningBalance(e.target.value)}
                        />
                    </FormControl>

                    <FormControl mt={{ base: 10, md: 6 }} width="15%">                        <CustomLabel  />
                        <Select
                            value={typeOfBalance}
                            onChange={(e) => setTypeOfBalance(e.target.value)}
                        >
                            <option value="1">Dr</option>
                            <option value="2">Cr</option>
                        </Select>
                    </FormControl>

                    <FormControl isRequired width="35%">
                        <CustomLabel labelText="Closing Balance" />
                        <CustomInput
                            placeholder="0.00"
                            type="number"
                            value={closingBalance}
                            onChange={(e) => setClosingBalance(e.target.value)}
                        />
                    </FormControl>

                    <FormControl mt={{ base: 10, md: 6 }} width="15%">                        <CustomLabel  />
                        <Select
                            value={typeOfBalanceClosing}
                            onChange={(e) => setTypeOfBalanceClosing(e.target.value)}
                        >
                            <option value="1">Dr</option>
                            <option value="2">Cr</option>
                        </Select>
                    </FormControl>
                </HStack>

                {fieldAdded && (
                    <Box>
                        {ledgerGroup === '28' ? (
                            <>
                                <Text fontWeight="bold">Bank Account Details:</Text>
                                <FormControl isRequired>
                                    <FormLabel>Account Number</FormLabel>
                                    <Input
                                        placeholder="Enter Account Number"
                                        value={accountNumber}
                                        onChange={(e) => setAccountNumber(e.target.value)}
                                    />
                                </FormControl>

                                <FormControl isRequired>
                                    <FormLabel>Bank Name</FormLabel>
                                    <Input
                                        placeholder="Enter Bank Name"
                                        value={bankName}
                                        onChange={(e) => setBankName(e.target.value)}
                                    />
                                </FormControl>

                                <FormControl isRequired>
                                    <FormLabel>Bank Branch</FormLabel>
                                    <Input
                                        placeholder="Enter Bank Branch"
                                        value={bankBranch}
                                        onChange={(e) => setBankBranch(e.target.value)}
                                    />
                                </FormControl>

                                <FormControl isRequired>
                                    <FormLabel>IFSC Code</FormLabel>
                                    <Input
                                        placeholder="Enter IFSC Code"
                                        value={ifscCode}
                                        onChange={(e) => setIfscCode(e.target.value)}
                                    />
                                </FormControl>

                                <FormControl>
                                    <FormLabel>Bank Address</FormLabel>
                                    <Textarea
                                        placeholder="Enter Bank Address"
                                        value={bankAddress}
                                        onChange={(e) => setBankAddress(e.target.value)}
                                    />
                                </FormControl>

                                <FormControl>
                                    <FormLabel>Bank Phone Number</FormLabel>
                                    <Input
                                        placeholder="Enter Bank Phone Number"
                                        value={bankPhoneNumber}
                                        onChange={(e) => setBankPhoneNumber(e.target.value)}
                                    />
                                </FormControl>

                                <FormControl>
                                    <FormLabel>Bank Email</FormLabel>
                                    <Input
                                        placeholder="Enter Bank Email"
                                        value={bankEmail}
                                        onChange={(e) => setBankEmail(e.target.value)}
                                    />
                                </FormControl>

                                <FormControl>
                                    <FormLabel>Bank Description</FormLabel>
                                    <Textarea
                                        placeholder="Enter Bank Description"
                                        value={bankDescription}
                                        onChange={(e) => setBankDescription(e.target.value)}
                                    />
                                </FormControl>

                                <FormControl>
                                    <FormLabel>MICR Code</FormLabel>
                                    <Input
                                        placeholder="Enter MICR Code"
                                        value={micrCode}
                                        onChange={(e) => setMicrCode(e.target.value)}
                                    />
                                </FormControl>

                                <FormControl>
                                    <FormLabel>Bank Integration</FormLabel>
                                    <Select
                                        placeholder="Select Integration"
                                        value={bankIntegration}
                                        onChange={(e) => setBankIntegration(e.target.value)}
                                    >
                                        <option value="Yes">Yes</option>
                                        <option value="No">No</option>
                                    </Select>
                                </FormControl>
                            </>
                        ) : (
                            <>
                                <Text fontWeight="bold">Customer Details:</Text>
                                <FormControl isRequired>
                                    <FormLabel>Mobile</FormLabel>
                                    <Input
                                        placeholder="Enter Mobile Number"
                                        value={mobile}
                                        onChange={(e) => setMobile(e.target.value)}
                                    />
                                </FormControl>

                                <FormControl isRequired>
                                    <FormLabel>Email</FormLabel>
                                    <Input
                                        placeholder="Enter Email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                    />
                                </FormControl>

                                <FormControl isRequired>
                                    <FormLabel>Tax Number</FormLabel>
                                    <Input
                                        placeholder="Enter Tax Number"
                                        value={taxNo}
                                        onChange={(e) => setTaxNo(e.target.value)}
                                    />
                                </FormControl>

                                <FormControl>
                                    <FormLabel>GP Days</FormLabel>
                                    <Input
                                        placeholder="Enter GP Days"
                                        value={gpDays}
                                        onChange={(e) => setGpDays(e.target.value)}
                                    />
                                </FormControl>

                                <FormControl>
                                    <FormLabel>Address</FormLabel>
                                    <Textarea
                                        placeholder="Enter Address"
                                        value={address}
                                        onChange={(e) => setAddress(e.target.value)}
                                    />
                                </FormControl>

                                <FormControl>
                                    <FormLabel>Place</FormLabel>
                                    <Input
                                        placeholder="Enter Place"
                                        value={place}
                                        onChange={(e) => setPlace(e.target.value)}
                                    />
                                </FormControl>
                            </>
                        )}

                        <Button
                            mt={4}
                            colorScheme="red"
                            onClick={handleHideFields}
                        >
                            Remove Additional Fields
                        </Button>
                    </Box>
                )}

                <Flex justify='space-between'>

                    {!fieldAdded && (
                        <Button
                            mt={4}
                            colorScheme="blue"
                            onClick={handleAddMoreFields}
                        >
                            Add More Fields
                        </Button>
                    )}

                    <Button
                        mt={6}
                        colorScheme="green"
                        onClick={handleSubmit}
                    >
                        Save Ledger
                    </Button>
                </Flex>
            </VStack>
        </Box>
    );
}

export default LeftFormSection;


